import { formatDeliveryDateDisplay } from './dateUtils';

// Copy for the All Orders offline info bar. `cacheRange` is null until the local
// cache read resolves, then { earliest: 'YYYY-MM-DD'|null, undated: number }.
// Offline the only real limit is the past boundary (all future is cached), so we
// state the earliest date "onward" rather than a two-ended span.
export const buildOfflineRangeMessage = (cacheRange) => {
  if (cacheRange === null) return 'Offline — read-only.';
  const { earliest, undated } = cacheRange;
  if (!earliest) {
    return undated > 0
      ? `Offline — ${undated} undated order${undated === 1 ? '' : 's'} available; no dated orders cached.`
      : 'Offline — no cached orders to view yet.';
  }
  const base = `Offline — you can view orders from ${formatDeliveryDateDisplay(earliest)} onward.`;
  return undated > 0 ? `${base} · ${undated} undated` : base;
};
